import { render, staticRenderFns } from "./AccountsDemandesList.vue?vue&type=template&id=b5b45064&scoped=true"
import script from "./AccountsDemandesList.vue?vue&type=script&lang=js"
export * from "./AccountsDemandesList.vue?vue&type=script&lang=js"
import style0 from "./AccountsDemandesList.vue?vue&type=style&index=0&id=b5b45064&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b45064",
  null
  
)

export default component.exports